import {Client} from '@stomp/stompjs';

const state = {
    stompClient: null,
    listenerList: [],       //监听器列表，断线重连时 用于重新注册监听
    //与后端的约定
    brokerURL: process.env.VUE_APP_EM_STOMP_URL, //websocket连接地址
    pointToPointTopicPrefix: "/user/queue/", //点对点订阅前缀
    broadcastTopicPrefix: "/queue/", //广播订阅前缀
};


function init({successCallback, errorCallback}) {
    const jwt = localStorage['em_sso_token']

    const client = new Client({
        brokerURL: state.brokerURL,
        connectHeaders: {
            jwt: jwt
        },
        debug: function (str) {
            console.log(str);
        },
        reconnectDelay: 5000,
        heartbeatIncoming: 4000,
        heartbeatOutgoing: 4000,
    });

    client.onConnect = function (frame) {
        // Do something, all subscribes must be done is this callback
        // This is needed because this will be executed after a (re)connect
        console.log('stomp.js init 连接成功！')
        //批量订阅
        state.listenerList.forEach(item => {
            client.subscribe(item.topic, item.callback, {id: item.id})
        })
        //执行回调
        successCallback && successCallback(frame)
    };

    client.onStompError = function (frame) {
        // Will be invoked in case of error encountered at Broker
        // Bad login/passcode typically will cause an error
        // Complaint brokers will set `message` header with a brief message. Body may contain details.
        // Compliant brokers will terminate the connection after any error
        console.log('Broker reported error: ' + frame.headers['message']);
        console.log('Additional details: ' + frame.body);
    };

    client.onWebSocketClose = function (frame) {
        console.log('stomp.js init 连接断开！')
        errorCallback && errorCallback(frame)
    }

    client.activate();
    state.stompClient = client
    console.log('stomp.js init finish')
}

function isConnected() {
    return state.stompClient != null && state.stompClient.connected;
}

function disconnect(callback) {
    state.stompClient != null && state.stompClient.deactivate()
}

function send(p) {
    state.stompClient != null && state.stompClient.publish({destination: p.topic, body: p.data, headers: p.headers})
}

function sendToPoint(p) {
    //拼接前缀
    send({topic: state.pointToPointTopicPrefix + p.topic, data: p.data})
}

function sendToBroadcast(p) {
    //拼接前缀
    send({topic: state.broadcastTopicPrefix + p.topic, data: p.data})
}

function subscribe(p) {
    //判空
    if (!state.listenerList) {
        state.listenerList = []
    }
    //如列表中没有该订阅，就添加
    if (!state.listenerList.some(f => f.id === p.id)) {
        state.listenerList.push(p)
    }
    //如果连接是可用的，就订阅
    //todo 如何避免重复订阅
    if (state.stompClient !== null && state.stompClient.connected) {
        state.stompClient.subscribe(p.topic, p.callback, {id: p.id})
    }
}

function subscribeToPoint(p) {
    //拼接前缀
    subscribe({
        topic: state.pointToPointTopicPrefix + p.topic,
        callback: p.callback,
        id: state.pointToPointTopicPrefix + p.id
    })
}

function subscribeToBroadcast(p) {
    //拼接前缀
    subscribe({
        topic: state.broadcastTopicPrefix + p.topic,
        callback: p.callback,
        id: state.broadcastTopicPrefix + p.id
    })
}

function unsubscribe(id) {
    if (state.listenerList) {
        for (let i = 0; i < state.listenerList.length; i++) {
            if (state.listenerList[i].id === id) {
                state.listenerList.splice(i, 1)
                break;
            }
        }
    }
    if (state.stompClient !== null && state.stompClient.connected)
        state.stompClient.unsubscribe(id)
}

function unsubscribeToPoint(id) {
    //拼接前缀
    unsubscribe(state.pointToPointTopicPrefix + id)
}

function unsubscribeToBroadcast(id) {
    console.log(id)
    //拼接前缀
    unsubscribe(state.broadcastTopicPrefix + id)
}

export default {
    init,
    isConnected,
    sendToPoint,
    sendToBroadcast,
    subscribeToPoint,
    subscribeToBroadcast,
    unsubscribeToPoint,
    unsubscribeToBroadcast,
    disconnect
};
